import {
  batchQueryUploadStatus,
  cancelUpload,
  deleteUploadFile,
  postPrepareSimpleUpload,
  postPrepareUpload,
  queryUploadStatus,
} from '@rendora/common/entities/upload_media_v3';
import type { IDataSource } from './types';

const DataSource: IDataSource = {
  async prepare(data) {
    return await postPrepareUpload(data);
  },
  async prepareSimpleUpload(data) {
    return await postPrepareSimpleUpload(data);
  },
  async queryStatus(params) {
    return await queryUploadStatus(params);
  },
  async batchQuery(params) {
    return await batchQueryUploadStatus(params);
  },
  async cancel(data) {
    return await cancelUpload(data);
  },
  async remove(params) {
    await deleteUploadFile(params);
  },
};

export default DataSource;
